module.exports = __webpack_public_path__ + "static/img/q1.fw.e840d76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/q1.fw.png
// module id = Op/2
// module chunks = 0